(function (Drupal) {
  'use strict';

  Drupal.behaviors.onethirttextwithmedia = {
    attach: function (context, settings) {
      const videoElements = context.querySelectorAll('[data-third-text-video]');

      videoElements.forEach(video => {
        // Ensure we only attach once
        if (video.dataset.onethirttextwithmediaProcessed) return;
        video.dataset.onethirttextwithmediaProcessed = true;

        const container = video.closest('.one-third-text-wmedia__content-wrapper');
        if (!container) return;

        const playBtn = container.querySelector('[data-third-text-play-btn]');
        const overlay = container.querySelector('.one-third-text-wmedia__video-overlay');
        const label = container.querySelector('[data-third-text-label]');

        if (!playBtn || !overlay || !label) return;

        // Toggle play/pause on button click
        playBtn.addEventListener('click', () => {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });

        // When video starts playing
        video.addEventListener('play', () => {
          overlay.classList.add('is-hidden');
          playBtn.classList.add('is-paused');
          video.setAttribute('controls', 'controls');
          label.textContent = 'PAUSE';
        });

        // When video is paused manually or via button
        video.addEventListener('pause', () => {
          if (!video.ended) {
            overlay.classList.remove('is-hidden');
            playBtn.classList.remove('is-paused');
            label.textContent = 'WATCH';
          }
        });

        // When video ends
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          video.removeAttribute('controls');
          overlay.classList.remove('is-hidden');
          playBtn.classList.remove('is-paused');
          label.textContent = 'WATCH';
        });
      });
    }
  };
})(Drupal);
